import { Avatar, Box, Stack, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import React, { useContext, useState } from "react";
import { AppContext } from "./../../lib/Context";

const MeetingsEvent = ({ event }) => {
  const [open, setOpen] = useState(false);
  const { userData } = useContext(AppContext);

  const toggleTooltip = (value) => {
    if (!value) {
      setTimeout(() => setOpen(false), 150);
    } else {
      setOpen(true);
    }
  };

  const commonTextStyle = {
    fontSize: "0.85rem",
    fontFamily: "Roboto",
    lineHeight: 1.6,
    color: "#333",
  };

  const returnTitle = (params, userData) => {

    if (userData?.designation === "Admin") {
      return params.agentName;
    }

    if (userData?.designation === "Sales Agent") {
      if (params.businessName && params.businessName !== "NA") {
        return params.businessName.length > 10
          ? params.businessName.slice(0, 10) + "..."
          : params.businessName;
      }

      if (params.title) {
        return params.title.length > 10
          ? params.title.slice(0, 10) + "..."
          : params.title;
      }
    }

    return ""; // Fallback return to avoid undefined
  };


  const renderInsideView = () => (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      onMouseEnter={() => toggleTooltip(true)}
      onMouseLeave={() => toggleTooltip(false)}
      onTouchStart={() => toggleTooltip(true)}
      sx={{
        borderRadius: "6px",
        cursor: "pointer",
      }}
    >
      <Typography fontSize={"0.75rem"} noWrap color={"secondary.dark"}>
        Meeting
      </Typography>
      <Typography lineHeight={1} fontSize={"0.85rem"} fontWeight={600} noWrap>
        {returnTitle(event, userData)}
      </Typography>
    </Stack>
  );

  const renderTooltipView = () => (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={1}
        bgcolor={"primary.main"}
        color={"white"}
      >
        <Typography fontSize="0.9rem" fontWeight={600}>
          📅 Meeting Details
        </Typography>
      </Stack>

      <Stack p={2} spacing={1.2}>
        {userData?.designation === "Admin" && (
          <Typography {...commonTextStyle}>
            <strong>Meeting for:</strong> {event?.agentName}
          </Typography>
        )}
        <Typography {...commonTextStyle}>
          <strong>Customer Name:</strong> {event?.username}
        </Typography>
        <Typography {...commonTextStyle}>
          <strong>Business:</strong> {event?.businessName}
        </Typography>
        <Typography {...commonTextStyle}>
          <strong>Meeting Date:</strong>{" "}
          {moment(event.meetingDateTime).format("DD.MM.YY [at] HH:mm")}
        </Typography>
        <Typography {...commonTextStyle}>
          <strong>Contact:</strong> {event?.contact}
        </Typography>
        <Typography {...commonTextStyle}>
          <strong>Address:</strong> {event?.address}
        </Typography>
        <Typography {...commonTextStyle}>
          <strong>Note:</strong> {event?.note}
        </Typography>
      </Stack>
    </Box>
  );

  return (
    <Tooltip
      open={open}
      title={renderTooltipView()}
      onClose={() => toggleTooltip(false)}
      onOpen={() => toggleTooltip(true)}
      disableHoverListener
      disableTouchListener
      placement="top"
      PopperProps={{
        sx: {
          zIndex: 1500,
          "& .MuiTooltip-tooltip": {
            padding: "0px",
            color: "#000000",
            backgroundColor: "#ffffff",
            border: "1px solid #ddd",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
            borderRadius: "8px",
            overflow: "hidden",
            minWidth: "320px",
            maxWidth: "420px",
          },
        },
      }}
    >
      <Box>{renderInsideView()}</Box>
    </Tooltip>
  );
};

export default MeetingsEvent;
